module.exports = __webpack_public_path__ + "static/media/ultrasound_probe_stablization_headset.85216cb2.jpeg";